import * as React from "react";
import {Col, Row} from "antd";

interface StatisticItemProps {
  left: React.ReactNode;
  right: React.ReactNode;
}

export default class StatisticsLayoutItem extends React.Component<StatisticItemProps, {}> {

  public render(): React.ReactNode {
    const {left, right} = this.props;
    return (
      <Row style={{height: 40}}>
        <Col xs={24} sm={16} className="statistics-layout-item-label">
          <span style={{marginRight: 8, color: '#000', opacity: 0.85}}>{left}</span>
        </Col>
        <Col xs={24} sm={8} className="statistics-layout-item-value">
          <span>{right}</span>
        </Col>
      </Row>
    );
  }
}


// WEBPACK FOOTER //
// ./src/statistics/utils/StatisticsLayoutItem.tsx